module.exports = __webpack_public_path__ + "img/kontakt_640.42afd9fa.png";